import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-font",
  "use": "icon-font-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-font\"><path d=\"M925.1584 64H98.83648c-17.11104 0-30.98624 13.62944-30.98624 30.72s13.8752 30.72 30.98624 30.72H478.72v799.13984c0 17.08544 13.60896 30.94016 30.72 30.94016s30.72-13.85472 30.72-30.94016V125.44h384.9984c17.11616 0 30.99136-13.62944 30.99136-30.72s-13.8752-30.72-30.99136-30.72z\" fill=\"#current\" p-id=\"7388\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol